function timeToClock(hours, minutes, seconds) {
  if (hours   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}

  if (hours === "00") return `${minutes}:${seconds}`;
  return `${hours}:${minutes}:${seconds}`;
}

function timeToFull(hours, minutes, seconds) {
    // localize
    let locHours = "hours";
    if (hours === 1) locHours = "hour";
    if (hours > 1 && hours < 5) locHours = "hours";

    let locMinutes = "minutes";
    if (minutes === 1) locMinutes = "minute";
    if (minutes > 1 && minutes < 5) locMinutes = "minutes";

    if (hours > 0) return `${hours} ${locHours} ${minutes} ${locMinutes}`;
    if (minutes > 0) return `${minutes} ${locMinutes}`;

    let locSeconds = "seconds";
    if (seconds === 1) locSeconds = "second";
    if (seconds > 1 && seconds < 5) locSeconds = "seconds";

    return `${seconds} ${locSeconds}`;
}

function timeToShort(hours, minutes, seconds) {
  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m`;
  return  `${seconds}s`;
}

// if optional is set, show clock time
function secondsToHms(sec, arg) {
  const hours = Math.floor(sec / 3600);
  const minutes = Math.floor(sec % 3600 / 60);
  const seconds = Math.floor(sec % 3600 % 60);

  if (arg === "clock") return timeToClock(hours, minutes, seconds);
  if (arg === "full") return timeToFull(hours, minutes, seconds);
  return timeToShort(hours, minutes, seconds);
}

export { secondsToHms }